import SelectTable from '../../../generic/selectTable';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import {STATUS_DRAFT, STEP_1} from '../../../../redux/slices/LomavisPostApproval/constants';
import { setApprovalKey } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { formatUsers } from './utils';
import {lomavisShowToastr} from "../../../../redux/slices/utils/ui/toastr";
import {TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED} from "../../../lomavisCreator/config/constants";

interface UserSelectTableProps {
  currentStep?: Number;
}

const UserSelectTable = ({ currentStep }: UserSelectTableProps) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const {
    data: {
      approval_step_2_users,
      approval_step_1_users,
      users,
      location_uuid,
      cloud_uuid,
      is_multipost,
      status
    }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const onSelect = (user: any): void => {
    if (status > STATUS_DRAFT) {
      lomavisShowToastr(
        t(TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED),
        'error'
      );
      return;
    }

    let selected = approval_step_1_users;
    let key = 'approval_step_1_users';

    if (currentStep !== STEP_1) {
      selected = approval_step_2_users;
      key = 'approval_step_2_users';
    }

    const userData = user.data || user;
    let newSelectedUsers = [];
    if (selected.some((u) => u.uuid === userData.uuid)) {
      newSelectedUsers = selected.filter(
        (u) => u.uuid !== userData.uuid
      );
    } else {
      newSelectedUsers = [...selected, userData];
    }
    dispatch(setApprovalKey({ key, value: newSelectedUsers }));
  };

  const selectedUsers = (currentStep === STEP_1
    ? approval_step_1_users
    : approval_step_2_users
  ).filter(Boolean);

  return (
    <>
      <div className="text-muted small mb-3">
        <div className="fw-semibold">
          {t('lomavisPostApproval.userSelectTable.selectableUsersHelpTitle')}
        </div>
        <div>
          {t('lomavisPostApproval.userSelectTable.selectableUsersHelpText')}
        </div>
      </div>
      <SelectTable
        data={formatUsers(users, {
          location_uuid,
          cloud_uuid,
          is_multipost
        })}
        onSelect={onSelect}
        selected={selectedUsers}
        canEdit={false}
        onEdit={() => {}}
      />
    </>
  );
};

export default UserSelectTable;
